//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SuspendedPage',

  layout: 'page',

  computed: {
    suspendedInfo() {
      const { target } = this.$route.query
      const plans = this.$auth.user.plans

      const map = {
        gohan_request: plans.gohan?.request,
        gohan_addon: plans.gohan?.addon_request,
      }

      return map[target] || {}
    },
    title() {
      return this.suspendedInfo.suspendedTitle
    },
    message() {
      return this.suspendedInfo.suspendedMessage
    },
  },
  mounted() {
    if (!this.suspendedInfo.suspended) {
      this.$router.replace('/')
    }
  },
}
